import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "ic-ui-card",
	templateUrl: "./ui-card.component.html",
	styleUrls: ["./ui-card.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class UICardComponent {
	@Input() isLoading = false;
	@Input() loadingText = "Loading";

	@Input() hasError = false;
	@Input() errorText = "Error";
}
